import { render, staticRenderFns } from "./CoursesViewTabGrades.vue?vue&type=template&id=26a5c784"
import script from "./CoursesViewTabGrades.vue?vue&type=script&lang=js"
export * from "./CoursesViewTabGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports